import Facebook from './Facebook'
import axios from 'axios'

// eslint-disable-next-line
function uploadVideoChunk (adaccount, access_token, start_offset, upload_session_id, formData) {
  return axios.post(`${adaccount}/advideos`, formData, {
    headers: {
      'content-type': 'multipart/form-data'
    },
    params: {
      access_token,
      upload_phase: 'transfer',
      start_offset,
      upload_session_id
    }
  })
    .then(res => {
      return res.data
    })
    .catch(err => {
      throw new Error(JSON.stringify(err))
    })
}
function transferVideo (adaccount, token, sessionId, start, end, file, number) {
  if (start === end) {
    return new Promise(resolve => {
      resolve(postVideo(adaccount, token, sessionId, file.name))
    })
  }
  const blob = new Blob([file], {type: file.type})
  const chunk = blob.slice(start, end, file.type)
  const formData = new FormData()
  formData.append('video_file_chunk', chunk, `@chunk${number}.${file.type.split('/')[1]}`)
  return new Promise(resolve => {
    resolve(uploadVideoChunk(
      adaccount,
      token,
      start,
      sessionId,
      formData
    ))
  })
    .then(res => {
      return new Promise(resolve => {
        resolve(transferVideo(adaccount, token, sessionId, res.start_offset, res.end_offset, file, number++))
      })
    })
    .catch(err => {
      throw new Error(JSON.stringify(err))
    })
}
// eslint-disable-next-line
function postVideo (adaccount, access_token, upload_session_id, title) {
  return axios({
    method: 'POST',
    url: `${adaccount}/advideos`,
    params: {
      access_token,
      upload_phase: 'finish',
      upload_session_id,
      title
    }
  })
    .then(res => {
      return res.data
    })
    .catch(err => {
      throw new Error(JSON.stringify(err))
    })
}

export default class Videos extends Facebook {
  constructor (user, parameters = null) {
    super(user)
    this.user = user
    this.parameters = parameters
  }
  fetchAccountVideos () {
    if (!this.user.selectedAdAccount) return
    return axios({
      method: 'GET',
      url: `${this.user.selectedAdAccount}/advideos`,
      params: {
        access_token: this.user.token
      }
    })
      .then(res => res.data.data)
      .catch(err => {
        throw new Error(JSON.stringify(err))
      })
  }
  getVideoById () {
    return axios({
      method: 'GET',
      url: `${this.parameters.id}`,
      params: {
        access_token: this.user.token,
        fields: 'title,icon,length,permalink_url,picture,source,created_time,updated_time,format'
      }
    })
    .then(res => res.data)
      .catch(err => {
        throw new Error(JSON.stringify(err))
      })
  }
  uploadVideo () {
    if (!this.user.selectedAdAccount) return
    return axios({
      method: 'POST',
      url: `${this.user.selectedAdAccount}/advideos`,
      params: {
        access_token: this.user.token,
        upload_phase: 'start',
        file_size: this.parameters.file.size
      }
    })
      .then(res => {
        const file = this.parameters.file
        return new Promise(resolve => {
          resolve(transferVideo(
            this.user.selectedAdAccount,
            this.user.token,
            res.data.upload_session_id,
            res.data.start_offset,
            res.data.end_offset,
            file,
            1
          ))
        })
      })
      .catch(err => {
        console.log(err, 'error')
        // throw new Error(JSON.stringify(err))
      })
  }
  deleteVideo () {
    return axios({
      method: 'DELETE',
      url: `/${this.parameters.id}`,
      params: {
        access_token: this.user.token
      }
    })
  }
}
